export const DPD_SITE_HTTP = 'https://www.dpd.co.uk';
export const DPD_LP_YOURDPD = `${DPD_SITE_HTTP}/lp/yourdpd`;
export const DPD_GREEN_SITE_HTTP = 'https://green.dpd.co.uk/';
